// extracted by mini-css-extract-plugin
module.exports = {"registeredUserBody":"RegisteredUser_registeredUserBody__2_tQq","zuzLogo":"RegisteredUser_zuzLogo__2i3lh"};